import { ApplicationState } from '../../../../store/types';
import { getDoraDataManagementRoot } from '../../store/selectors';
import { DataManagementTile } from './types';

export const getSelectedTab = (state: ApplicationState): DataManagementTile | null => getDoraDataManagementRoot(state).selectedTab;
